import { css } from 'lit';
import { fsDesignToken } from './core/style-util.js';

export const style = css`
  :host {
    display: block;
  }

  .side-padding {
    padding: 0 ${fsDesignToken('fsSizeSpacingSmall2')};
  }

  .max-content-width {
    width: max-content;
  }
`;
